export const isValidEmail = (email) => {
  return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{3,}))$/.test(
    email
  );
};

export const isEmptyField = (value) => {
  return value.trim() === "";
};

/** Normalize profile/measurement weight for display, e.g. 185 → "185 lbs.", 190 lbs → "190 lbs." */
export const formatWeightDisplay = (weight, empty = "--") => {
  if (weight == null || weight === "") return empty;
  const s = String(weight).trim();
  if (!s) return empty;
  const numeric = s.replace(/\s*lbs\.?\s*$/i, "").trim();
  if (!numeric) return empty;
  return `${numeric} lbs.`;
};

/** Composite / industry rank strings we should not show in the UI. */
export const isDisplayableIndustryRankValue = (value) => {
  if (value === null || value === undefined) return false;
  const s = String(value).trim();
  if (!s) return false;
  if (/^n\/?a$/i.test(s)) return false;
  if (/^--?$/.test(s) || s === "\u2014") return false;
  if (/^tbd$/i.test(s)) return false;
  return true;
};
